import {Injectable} from '@angular/core';
import {BaseurlService} from './baseurl.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {WeightModel} from '../model/WeightModel';

@Injectable({
  providedIn: 'root'
})
export class WeightService {

  constructor(
    private baseurlService: BaseurlService,
    private http: HttpClient
  ) { }

  getAllWeightEntries(): Observable<WeightModel[]> {
    return this.http.get<WeightModel[]>(`${this.baseurlService.getBaseUrl()}/weight`);
  }

  save(save: WeightModel): Observable<WeightModel> {
    if (!save.id) {
      return this.http.post<WeightModel>(`${this.baseurlService.getBaseUrl()}/weight`, save);
    } else {
      return this.http.put<WeightModel>(`${this.baseurlService.getBaseUrl()}/weight/${save.id}`, save);
    }
  }
}
